import { CollectionMetafields } from "~/types";

type CollectionListProps = {
    collection: CollectionMetafields,
}

export default function CustomCollectionList({ collection }: CollectionListProps) {

    return (<>
    </>);
}